import { useTranslation } from 'react-i18next';

export default function Testimonials() {
  const { t } = useTranslation('common');

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-white to-purple-50 dark:from-gray-900 dark:to-purple-900/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-black text-blue-900 dark:text-teal-400 leading-tight">
            {t('testimonials.title')}<br />{t('testimonials.titleLine2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5">
          <div className="bg-blue-50 dark:bg-gray-800 rounded-3xl p-8 hover:shadow-xl transition-all">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white font-bold">
                MC
              </div>
              <div>
                <div className="font-bold text-gray-900 dark:text-gray-100">{t('testimonials.user1')}</div>
                <div className="text-sm text-gray-600 dark:text-gray-400">{t('testimonials.user1Since')}</div>
              </div>
            </div>
            <div className="text-purple-500 text-5xl mb-4">"</div>
            <p className="text-gray-800 dark:text-gray-300 text-base leading-relaxed">
              {t('testimonials.user1Text')}
            </p>
          </div>

          <div className="bg-blue-50 dark:bg-gray-800 rounded-3xl p-8 hover:shadow-xl transition-all">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-yellow-500 rounded-full flex items-center justify-center text-white font-bold">
                JS
              </div>
              <div>
                <div className="font-bold text-gray-900 dark:text-gray-100">{t('testimonials.user2')}</div>
                <div className="text-sm text-gray-600 dark:text-gray-400">{t('testimonials.user2Since')}</div>
              </div>
            </div>
            <div className="text-orange-500 text-5xl mb-4">"</div>
            <p className="text-gray-800 dark:text-gray-300 text-base leading-relaxed">
              {t('testimonials.user2Text')}
            </p>
          </div>

          <div className="relative rounded-3xl overflow-hidden h-80 hover:shadow-xl transition-all">
            <img 
              src="https://public.readdy.ai/ai/img_res/c6292c2051d3708d133d51e60906ff89.jpg"
              alt="User testimonial"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
              <div className="text-white font-bold text-xl">{t('testimonials.user3')}</div>
              <div className="text-white/80 text-sm">{t('testimonials.user3Location')}</div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="md:col-span-2 relative rounded-3xl overflow-hidden h-64 hover:shadow-xl transition-all">
            <img 
              src="https://readdy.ai/api/search-image?query=group%20of%20diverse%20Latin%20American%20friends%20laughing%20together%20while%20using%20smartphones%2C%20casual%20outdoor%20setting%20with%20vibrant%20colors%2C%20warm%20sunlight%20and%20happy%20atmosphere%2C%20modern%20lifestyle%20photography%20showing%20friendship%20and%20social%20connection%2C%20natural%20and%20joyful%20scene&width=900&height=500&seq=testimonial-group-001&orientation=landscape"
              alt="Happy users"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-blue-900/90 to-transparent p-8">
              <div className="text-white font-bold text-2xl mb-1">{t('testimonials.user4')}</div>
              <div className="text-white/80 text-base mb-2">{t('testimonials.user4Location')}</div>
              <p className="text-white text-base">
                "{t('testimonials.user4Text')}"
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <div className="bg-blue-50 dark:bg-gray-800 rounded-3xl p-6 flex-1 hover:shadow-xl transition-all">
              <p className="text-gray-800 dark:text-gray-300 text-sm leading-relaxed mb-4">
                "{t('testimonials.user5Text')}"
              </p>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-gradient-to-br from-teal-500 to-green-500 rounded-full flex items-center justify-center text-white text-xs font-bold">
                  LG
                </div>
                <div className="text-sm font-semibold text-gray-900 dark:text-gray-100">{t('testimonials.user5')}</div>
              </div>
            </div>

            <div className="bg-blue-50 dark:bg-gray-800 rounded-3xl p-6 flex-1 hover:shadow-xl transition-all">
              <p className="text-gray-800 dark:text-gray-300 text-sm leading-relaxed mb-4">
                "{t('testimonials.user6Text')}"
              </p>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-gradient-to-br from-red-500 to-pink-500 rounded-full flex items-center justify-center text-white text-xs font-bold">
                  DP
                </div>
                <div className="text-sm font-semibold text-gray-900 dark:text-gray-100">{t('testimonials.user6')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
